export const DEFAULT_ID = "1"
export const DEFAULT_NAME = "Start"

export type BoardType = {
  id: string
  name: string
}
